module.exports = {"420503001":"大公桥街道","420503002":"万寿桥街道","420503003":"宝塔河街道","420503004":"伍家岗街道","420503201":"伍家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420503.json
// module id = 1849
// module chunks = 0